/**
 * Extracts the trailing numeric segment from a comment ARI.
 *
 * Examples:
 *   "ari:cloud:confluence:tenant:comment/12345" → "12345"
 *   "12345"                                     → "12345"  (already numeric)
 */
export const extractNumericCommentId = (commentAri: string): string => {
	const parts = commentAri.split('/');
	return parts[parts.length - 1] || commentAri;
};
